import unifarmFactoryABI from './abis/unifarmFactoryABI.json';
import childPoolABI from './abis/childPoolABI.json';
import poolABI from "./abis/poolABI.json";
import claimRequestABI from "./abis/unstakeABI.json";
let unifarmFactory ={
    address: '0x9c9a6CEffcCF482d80842fC49dcb0345C9b65802',
    abi: unifarmFactoryABI,
    rootTokens: 'https://gateway.thegraph.com/api/subgraphs/id/BadYtmZk4FAHCF7C8mqXcJpiwXxMwmte5MKiJK5cgjuE' //"https://api.studio.thegraph.com/query/80537/unifarm/version/latest"

}

let childPool = {
    abi: childPoolABI
}
let newPool = {
    abi:poolABI
}
let claimRequestContract = {
    abi:claimRequestABI
}
export { unifarmFactory, childPool, newPool, claimRequestContract };
